import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext'
import { dedupedRequest } from '../utils/axios';
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


type Role = 'admin' | 'superadmin' | 'lawyer' | 'client' | 'justiz';

const Login = () => {
  const navigate = useNavigate();
  const { login, isAuthenticated, user } = useAuth();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const redirectPath: Record<Role, string> = {
      admin: '/dashboard',
      superadmin: '/clientselection',
      lawyer: '/clientselection',
      client: '/dashboard',
      justiz: '/justiz',
    }
    // if (isAuthenticated && user && (user.role === "lawyer" || user.role === "superadmin")) {
    if (isAuthenticated && user) {
      navigate(redirectPath[user.role as Role] || '/');
    }
  }, [isAuthenticated, user, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (loading) return; // Prevent multiple submissions
    setLoading(true);
    setError('');
    try {
      const res = await dedupedRequest<{ access_token_cookie: string }>(
        {
          method: 'POST',
          url: '/login',           // baseURL '/api' is applied in axios.ts
          data: { email, password },
          withCredentials: true,   // ensure refresh cookie is set on successful login
          headers: { 'Content-Type': 'application/json' },
        },
        { useCache: false, maxRetries: 0 } // no caching; avoid retries on bad creds
      );

      // console.log('Login response:', res.data);

      const token = res.data?.access_token_cookie;
      if (!token) {
        throw new Error('Login succeeded but no access token was returned.');
      }
      login(token); // triggers the effect-based redirect
    } catch (err: any) {
      // Axios errors often have response.data with details
      let msg = 'Login fehlgeschlagen';
      
      // Check for 401 Unauthorized - show user-friendly message
      if (err?.response?.status === 401) {
        msg = 'Falsche Anmeldedaten. Bitte überprüfen Sie Ihre E-Mail-Adresse und Ihr Passwort.';
      } else {
        msg =
          err?.response?.data?.message ||
          err?.response?.data?.detail ||
          err?.message ||
          msg;
      }
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="mt-5">
      <Row className="justify-content-md-center">
        <Col md="auto">

      <form onSubmit={handleSubmit}>
        <Card style={{ width: '24rem' }}>
          <Card.Body>
            <Card.Title><h2>Login</h2></Card.Title>
            <div className="mb-3">
              <div data-mdb-input-init className="form-outline mb-2">
                <input
                  className='form-control'
                  id="emailInput"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="E-Mail-Adresse"
                  required
                />
              </div>
              <div data-mdb-input-init className="form-outline mb-2">
                <input
                  className='form-control'
                  id="passwordInput"
                  type="password" // password
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Passwort"
                  required
                />
              </div>
              <button type="submit" data-mdb-button-init data-mdb-ripple-init className="btn btn-primary btn-block mb-4">Anmelden</button>
              <p>Passwort vergessen? <a href="/password-request">Hier klicken</a></p>
              {error && <p style={{ color: 'red' }}>{error}</p>}
            </div>
          </Card.Body>
        </Card>

      </form>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;
